import { render, staticRenderFns } from "./boolean-search-filter.vue?vue&type=template&id=836ff3ea&scoped=true&"
import script from "./boolean-search-filter.vue?vue&type=script&lang=js&"
export * from "./boolean-search-filter.vue?vue&type=script&lang=js&"
import style0 from "./boolean-search-filter.vue?vue&type=style&index=0&id=836ff3ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836ff3ea",
  null
  
)

export default component.exports